import type { IProModalCustomStyles } from "pro-features/components/Modals/src/ProModal";
import type { IRankTrackerChangeProps } from "app/pages/digital-marketing/keywords-campaigns/reports/shared/Table/expandedTable/RankTrackerExpandedTableTypes";

import type { IDataPoint } from "../../../reports/keywords-report/keywords-table/KeywordsReportTypes";
import type { ILanguageLocaleAndDescription } from "../../../reports/shared/Table/TableUtils/RankTrackerTablesTypes";
import type { TargetUrlColumnData } from "../../../reports/trend-report/TrendReportsTypes";

interface ISetTargetUrlModalTagsProps {
    text: string;
}
interface ISetTargetUrlModalTableDataProps {
    keyword: string;
    tags: string[] | ISetTargetUrlModalTagsProps[];
    topUrl?: string;
    geoLocation: string | ILanguageLocaleAndDescription;
    scrapingConfigurationId: string;
    position?: { [site: string]: IRankTrackerChangeProps };
    trend: IDataPoint[];
    volume: number;
    cpc?: number;
    difficulty?: number;
    lastUpdated?: string;
    intent?: string;
    urlCount?: number;
    serpFeatures?: {
        keywordSerpFeatures: string[];
        siteSerpFeatures: {
            [key: string]: string[];
        };
    };
    targetUrls: string[];
    positionTrend?: IDataPoint[];
    targetUrlOverTime?: TargetUrlColumnData[];
}

export interface ISetTargetUrlModalTableDataRecordsProps {
    records: ISetTargetUrlModalTableDataProps[];
    totalCount?: number;
}

export interface ISetTargetUrlModalProps {
    isOpen: boolean;
    onCancel: () => void;
    onSave: (url: string) => void;
    initialUrl?: string;
    isInitialUrlChanged?: boolean;
    showBulkEditBanner?: boolean;
}

export const targetUrlProModalStyles: IProModalCustomStyles = {
    content: {
        width: "400px",
    },
};
